module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof08"
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Graduates of the Artillery and Engineer Cadet Corp/2nd Cadet Corps in 1762-1855")]), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent51",
      "id": "theft51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "imgfr4",
      "src": "images/imgfr4.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66ae59ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof08.vue
// module id = 117
// module chunks = 0